import React from 'react';
import background from '../../assets/lanternfish.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoLanternfish extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="FOOD WEB"
        description="Lanternfish"
        paragraph="The lanternfish, also known as Symbolophorus barnardi, is a deep-water fish that gets its name from its ability to produce light. They make up 65% of the deep sea biomass."
        background={background}
     />
  
  );
 }
}   

export default InfoLanternfish;